import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
import Styles from "./Home.module.scss";
import { userMenu, superAdminMenu, clientMenu, ManagerMenu, FinanceMenu, filterMenuByPermissions, orgAdminMenu, orgEmployeeMenu } from "./Menu";
import Header from "../Header/Header";
import { Sidebar } from "../../components/Sidebar/Sidebar";
import Navbar from "../../components/Navbar/Navbar";
import { getTokenbyData } from "../../services/user.service";
import { ToastError } from "../../utils/Toaster/Toaster";
import { useAuth } from "../../context/AuthProvider";
import { usePermissions } from "../../context/PermissionProvider";
import NotificationPrompt from "../../components/NotificationPrompt";
import { requestNotificationPermission } from "../../firebase-config";
import { isAdminRole, isOrgEmployee, ROLES } from "../../utils/roles";

const Home = () => {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const { permissions, loading: permissionsLoading } = usePermissions();

  // eslint-disable-next-line no-unused-vars
  const [menu, setMenu] = useState([]);
  const [sidebarMode, setSidebarMode] = React.useState("open"); // 'open' | 'collapsed' | 'closed'
  const handleNavigate = (e) => {
    if (e === "login") {
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("role");
      localStorage.removeItem("userName");
      navigate("/login");
    } else {
      navigate(e.path);
    }
  };
  const toggleSidebar = () => {
    setSidebarMode((prev) => (prev === "open" ? "collapsed" : "open"));
  };
  const closeSidebar = () => setSidebarMode("closed");
  // const token = localStorage.getItem("token");

  useEffect(() => {
    if (accessToken && !permissionsLoading) {
      const fetchData = async () => {
        try {
          const res = await getTokenbyData();
          const role = res?.data?.role;
          const orgId = res?.data?.orgId;

          let baseMenu = [];
          if (role === ROLES.ORG_ADMIN) {
            baseMenu = orgAdminMenu;
          } else if (isOrgEmployee(role, orgId)) {
            baseMenu = orgEmployeeMenu;
          } else if (isAdminRole(role)) {
            // Admin - show all menu items (no filtering needed)
            baseMenu = superAdminMenu;
          } else if (role === 3) {
            baseMenu = clientMenu;
          } else if (role === 5) {
            baseMenu = ManagerMenu;
          } else if (role === 6) {
            baseMenu = FinanceMenu;
          } else {
            baseMenu = userMenu;
          }

          // For non-admin users, filter menu based on permissions. Admin roles
          // (including Org Admin, whose menu is already fixed to its two
          // modules) are granted everything client-side, so filtering is a no-op.
          if (!isAdminRole(role) && !isOrgEmployee(role, orgId) && permissions) {
            const filteredMenu = filterMenuByPermissions(baseMenu, permissions);
            setMenu(filteredMenu);
          } else {
            setMenu(baseMenu);
          }
        } catch (error) {
          console.error("Error fetching role data:", error);
        }
      };

      fetchData();
    } else if (accessToken && permissionsLoading) {
      // Wait for permissions to load
      return;
    } else {
      navigate("/login");
      ToastError("Please Login Again");
    }
  }, [accessToken, permissions, permissionsLoading]);

  const handleRequestPermission = async () => {
    console.log('🔔 [Home] User clicked to enable notifications');
    await requestNotificationPermission();
  };

  return (
    <>
      {/* <div className={Styles.HomeMain}> */}
      {/* <div className={Styles.Navbar}>
          <Navbar />
        </div> */}
      <div className={Styles.RenderingMainContainer}>
        <div
          className={`${Styles.Sidebar} ${sidebarMode === "collapsed" ? Styles.collapsed : ""} ${sidebarMode === "closed" ? Styles.closed : ""}`}
        >
          <Sidebar
            Menu={menu}
            onNavigate={handleNavigate}
            title="LMT"
            isCollapsed={sidebarMode === "collapsed"}
            toggleSidebar={toggleSidebar}
            onClose={closeSidebar}
          />
        </div>

        <div
          className={`${Styles.RenderingBox} ${sidebarMode === "collapsed" ? Styles.collapsed : ""} ${sidebarMode === "closed" ? Styles.closed : ""}`}
        >
          <div className={Styles.header}>
            <Header
              onOpenSidebar={sidebarMode === "closed" ? () => setSidebarMode("open") : undefined}
            />
          </div>
          {/* <Divider sx={{ opacity: 0.4 }} /> */}
          <div className={Styles.MainContentWrapper}>
            <div className={Styles.MainContainer}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      {/* Notification Permission Prompt */}
      <NotificationPrompt onRequestPermission={handleRequestPermission} />
    </>
  );
};

export default Home;
